import { combineReducers } from 'redux-immutablejs';

import Orders from './Orders';
import OrdersGroupNoManagement from './OrdersGroupNoManagement';
import Products from './Products';
import ProductsCollection from './ProductsCollection';
import Tickets from './Tickets';
import TicketsStock from './Tickets/Stock';
import TicketsInstructio from './Tickets/Instructio';
import Supplier from './Supplier';
import DestinationCollection from './DestinationCollection';
import OAccountReconciliationSupplier from './Legder/AccountReconciliationSupplier';
import LegderSupplierGeneralLedger from './Legder/Supplier';
import Users from './Users';
import EnterpriseBillCheck from './Enterprise/BillCheck';
import Statistics from './Statistics/Statistics';
import KPI from './Statistics/KPI';
import Traveller from './Statistics/Traveller';
import Baseinfo from './Baseinfo'

// import Currency from './Currency';
export default combineReducers({
  Orders,
  OrdersGroupNoManagement,
  Products,
  ProductsCollection,
  Supplier,
  DestinationCollection,
  OAccountReconciliationSupplier,
  LegderSupplierGeneralLedger,
  Users,
  TicketsInstructio,
  EnterpriseBillCheck,
  Statistics,
  KPI,
  Traveller,
  Baseinfo
});

//
